"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _mui = require("tss-react/mui");
var _Fade = _interopRequireDefault(require("@mui/material/Fade"));
var _CircularProgress = _interopRequireDefault(require("@mui/material/CircularProgress"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var useStyles = (0, _mui.makeStyles)()(function (theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    },
    message: {
      marginTop: theme.spacing(2),
      fontWeight: 'bold'
    },
    absolute: {
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      backgroundColor: theme.palette.common.white,
      zIndex: 1
    },
    loaderStyle: {
      color: theme.palette.secondary.light
    }
  };
});
var Loader = function Loader(_ref) {
  var loading = _ref.loading,
    message = _ref.message,
    variant = _ref.variant,
    className = _ref.className,
    size = _ref.size;
  var _useStyles = useStyles(),
    classes = _useStyles.classes,
    cx = _useStyles.cx;
  return /*#__PURE__*/_react["default"].createElement(_Fade["default"], {
    "in": loading,
    timeout: 400,
    mountOnEnter: true,
    unmountOnExit: true
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: cx(classes.root, classes[variant], className)
  }, /*#__PURE__*/_react["default"].createElement(_CircularProgress["default"], {
    className: classes.loaderStyle,
    thickness: 4.5,
    size: size
  }), message && /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    className: classes.message,
    component: "p",
    variant: "subtitle1"
  }, message)));
};
Loader.propTypes = {
  className: _propTypes["default"].string,
  loading: _propTypes["default"].bool.isRequired,
  message: _propTypes["default"].string,
  variant: _propTypes["default"].oneOf(['absolute', 'default']),
  size: _propTypes["default"].number
};
Loader.defaultProps = {
  className: undefined,
  message: undefined,
  variant: 'default',
  size: 50
};
var _default = Loader;
exports["default"] = _default;